<div class="modal-header">
    <h2 class="modal-title">{{'request.filterPopup.title' | translate}}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeHandler()">
    </button>
</div>

<div class="modal-body">
    <div class="issue-date">
        {{'request.filterPopup.issueDate' | translate}}
    </div>
    <div class="row">
        <div class="col-md-6">
            <label class="label-input">
                {{'request.filterPopup.fromDate' | translate}}
            </label>
            <kendo-datepicker HJSuppress
                [(ngModel)]="startDate"
                (ngModelChange)="startDateChangeHandler()" 
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                #startDateInput
                (click)="!startDateInput.isOpen ? startDateInput.toggle() : ''"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                >
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
        <div class="col-md-6">
            <label class="label-input">
                {{'request.filterPopup.toDate' | translate}}
            </label>
            <kendo-datepicker HJSuppress
                [(ngModel)]="endDate"
                class="custom-kendo-control-xl"
                [fillMode]="fillModeOutline"
                [rounded]="roundedLarge"
                #endDateInput
                (click)="!endDateInput.isOpen ?endDateInput.toggle() : ''"
                [disabledDates]="disabledPastDates"
                [popupSettings]="{popupClass : 'data-hj-suppress'}"
            >   
                <kendo-datepicker-messages
                    today="{{ 'calendar.today' | translate }}"
                    toggle="{{ 'calendar.toggle' | translate }}"
                >
                </kendo-datepicker-messages>
            </kendo-datepicker>
        </div>
    </div>

    <div class="separator"></div>

    <div class="row modal-section">
        <div class="col-md-12 title-txt">
            <label class="category-name-label">
                {{'request.filterPopup.assetDocumentRequest' | translate}}
            </label>
        </div>

        <div class="container-fluid">
            <div class="row" *ngFor="let requestType of dictionaryAssetDocumentRequestTypeDataSource">
                <div class="col-md-6 radio-container">
                    <input  class="radio-input" type="radio" kendoRadioButton size="large" 
                        [id]="requestType.id"
                        name="answer" 
                        [value]="requestType.id"  
                        [(ngModel)]="selectedRequestTypeId"
                    >
                    <label class="radio-label" [for]="requestType.id">
                        {{requestType.value}}
                    </label>
                </div>
            </div>
        </div>
    </div>

    <div class="separator"></div>

    <div class="row modal-section">
        <div class="col-md-12 title-txt">
            <label class="category-name-label">
                {{'request.filterPopup.contractModificationsRequest' | translate}}
            </label>
        </div>

        <div class="row" *ngFor="let requestType of dictionaryContractModificationRequestTypeDataSource">
            <div class="col-md-6 radio-container">
                <input class="radio-input" type="radio" kendoRadioButton size="large" 
                    [id]="requestType.id"
                    name="answer" 
                    [value]="requestType.id"  
                    [(ngModel)]="selectedRequestTypeId"
                >
                <label class="radio-label" [for]="requestType.id">
                    {{requestType.value}}
                </label>
            </div>
        </div>
    </div>

    <div class="separator"></div>

    <div class="row modal-section">
        <div class="col-md-12 title-txt">
            <label class="category-name-label">
                {{'request.filterPopup.clientDataRequest' | translate}}
            </label>
        </div>

        <div class="row" *ngFor="let requestType of dictionaryClientDataRequestTypeDataSource">
            <div class="col-md-6 radio-container">
                <input class="radio-input" type="radio" kendoRadioButton size="large" 
                    [id]=" requestType.id"
                    [(ngModel)]="selectedRequestTypeId"
                    name="answer" 
                    [value]="requestType.id"  
                >
                <label class="radio-label" [for]=" requestType.id">
                    {{ requestType.value}}
                </label>
            </div>
        </div>
    </div>

    <div class="separator"></div>

    <div class="col-md-12 title-txt">
        <label class="category-name-label">
            {{'request.filterPopup.lastModifiedBy' | translate}}
        </label>
    </div>

    <div class="input-dropdown-container cursor-pointer">
        <kendo-combobox HJSuppress
            class="custom-kendo-control-xl" 
            [fillMode]="fillModeOutline"
            [rounded]="roundedLarge"
            [size]="sizeLarge"
            name="chooseEmployee"
            [placeholder]="'request.filterPopup.chooseEmployee' | translate"
            [clearButton]="true"
            [data]="adminUsersDataSource"
            [textField]="'value'"
            [valueField]="'id'"
            [valuePrimitive]="false"
            [(ngModel)]="selectedAdminUser"
            #chooseEmployeeComboBox
            (click)="!chooseEmployeeComboBox.isOpen ? chooseEmployeeComboBox.toggle() : null"
            [popupSettings]="{popupClass : 'data-hj-suppress'}"
        >
        </kendo-combobox>
    </div>
</div>

<div class="modal-footer">
    <button class="btn link-btn" (click)="resetHandler()">
        <i class="app-icon icon icon-reload icon-lg me-2"></i> 
        {{'request.filterPopup.reset' | translate}}
    </button>
    <button class="btn primary-btn" (click)="applyFilterHandler()">
        {{'request.filterPopup.apply' | translate}}
    </button>
</div>